module.exports = __webpack_public_path__ + "static/img/blue1.e1262000.png";